import React, { useEffect } from 'react'
import { Button } from 'react-bootstrap';
import { kirkos_logo_black_yellow } from '../../../assets/images';
import "./apkhome.scss";
import { Link } from 'react-router-dom';
import { trackEvent } from '../../../services/events';
import SEO from '../../../components/SEO';

const ApkHome: React.FC = () => {
    return (
        <div className='apk-home'>
            <SEO
                title="Kirkos UAE | Rent A Car Anytime"
                description="Download the Kirkos app or sign up here to start your journey with premium car rentals in the UAE."
                keywords="car rental app, Kirkos APK, rent a car mobile"
            />
            <div className='apk-home-bg' />
            <div className='apk-home-bg-bottom' />
            <div className="apk-home-bg-img" />
            <div className='pt-5'>
                <img src={kirkos_logo_black_yellow} alt="" />
            </div>
            <div className='navigate-btn-apk'>
                <div className='responsive-text-apk'>
                    RENT A CAR & MAKE YOUR <br /> TRIP'S ENJOYABLE
                </div>
                <div className='padding-top-navigate-btn'>
                    <Link to="/signup">
                        <Button
                            className='apk-home-button-style'
                            onClick={async () => {
                                await trackEvent({
                                    event_name: { web: "Kirkos_SignUp_Click", app: "Kirkos_SignUp_Click_App" },
                                    event_category: "appTesting",
                                    module: "ApkHome",
                                    payload: "{}",
                                });
                            }}
                        >
                            SIGN UP
                        </Button>
                    </Link>
                    &nbsp;
                    <Link to="/signin">
                        <Button
                            className='apk-home-button-style'
                            onClick={async () => {
                                await trackEvent({
                                    event_name: { web: "Kirkos_SignIn_Click", app: "Kirkos_SignIn_Click_App" },
                                    event_category: "appTesting",
                                    module: "ApkHome",
                                    payload: "{}",
                                });
                            }}
                        >
                            SIGN IN
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default ApkHome